import { useState, useEffect, useRef } from 'react';

/**
 * Simple hook that returns the original image URL.
 * The enhance-property-image edge function requires authentication,
 * so we skip enhancement on public pages to avoid 401 errors.
 */
export const useEnhancedImage = (originalUrl: string | undefined | null) => {
  return { 
    displayUrl: originalUrl || '', 
    isEnhancing: false,
    isEnhanced: false 
  };
};